import { useFormContext } from '@calendly/form'
import { useOnValueChange } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { isEqual, omit } from 'lodash-es'
import { useMemo } from 'react'

import { selectLocation, selectLocationConfiguration } from './actions'
import { Location } from './location'
import { sortedActiveLocationsSelector } from './selectors'
import { useDispatchValue, useStateValue } from './state_provider'

export const LocationList = ({ isSelectedForAllHosts, setIsSelectedForAllHosts, dropdownWrapper, hideErrors, isDisabled }) => {
  const sortedLocations = sortedActiveLocationsSelector(useStateValue())
  const dispatch = useDispatchValue()
  const { values } = useFormContext()
  const memberships = useMemo(() => {
    const isCollectiveRoundRobin = (values.poolingType || values.pooling_type) === 'multi_pool'

    if (!values?.memberships) { return [] }
    if (!isCollectiveRoundRobin) { return values.memberships }

    const userPool = (values.user_pools || values.userPools)[0]

    return values.memberships.filter((membership) => membership.user_pool_uid === (userPool?.uuid || userPool?.key))
  }, [values])

  useOnValueChange(memberships, () => {
    // Refactor: CAL-56231
    // This is used to get location dropdowns to update on RR event types when "select for all" is selected
    // It's important to note that all location dropdowns have their own private state that are independant from
    // one another.
    if (isSelectedForAllHosts) {
      const locationConfiguration = memberships[0].locationConfiguration
      const [locationId, location] = sortedLocations[0]

      if (locationConfiguration
        && !locationConfiguration._destroy
        && !isEqual(omit(locationConfiguration, ['id', 'position', '_destroy']), omit(location, ['id', 'position', '_destroy']))) {
        dispatch(selectLocation(locationId, locationConfiguration.kind))
        dispatch(selectLocationConfiguration(locationId, locationConfiguration))
        setIsSelectedForAllHosts(false)
      }
    }
  })

  return (
    <>
      {sortedLocations.map(([id, location], index) => (
        <Location
          key={id}
          locationId={id}
          location={location}
          setIsSelectedForAllHosts={setIsSelectedForAllHosts}
          aria-label={`${I18n.t('publisher.event_types.location.location')}${index > 0 ? ` ${(index + 1)}` : ''}`}
          dropdownWrapper={dropdownWrapper}
          hideErrors={hideErrors}
          isDisabled={isDisabled}
        />
      ))}
    </>
  )
}
